import React, { useState, useEffect } from 'react';
import { useAuthHeader } from 'react-auth-kit';
import axios from 'axios';
import { Modal, Container, Row, Col, ButtonToolbar, Button, Form} from 'react-bootstrap';
import * as Icon from 'react-feather';
import { PERMISSION_PAGES, buildDefaultPermissionsForRoles } from '../../../../config/roleConfig';

function DefaultModal(props) {
    const authHeader = useAuthHeader();
    const apiUrl = process.env.REACT_APP_URL;

        const [role, setRole] = useState([]);
        const [roleCommissions, setRoleCommissions] = useState({});
        const [operadorLocalCommission, setOperadorLocalCommission] = useState('');
        const [clients, setClients] = useState([]);
        const [selectedClientId, setSelectedClientId] = useState('');
        const [permissions, setPermissions] = useState(() => buildDefaultPermissionsForRoles([]));

        const roleLabels = {
            '2': 'Operador',
            '3': 'Vendedor',
            '4': 'Tráfico',
            '5': 'Monitorista',
            '6': 'Compras',
            '7': 'Finanzas',
            '8': 'RRHH',
            '9': 'Facturación',
            '10': 'Taller',
            '11': 'Cliente'
        };

        const rolesToPermissionRoles = (roleIds) => roleIds.map(roleId => ({
            title: roleLabels[roleId]
        }));

        // Check if Cliente role (11) is selected
        const isClienteRoleSelected = role.includes('11');

        // Fetch clients when Cliente role is selected
        useEffect(() => {
            if (isClienteRoleSelected && clients.length === 0) {
                fetchClients();
            }
        }, [isClienteRoleSelected]);

        const fetchClients = () => {
            axios({
                method: 'GET',
                url: apiUrl + '/finance/get_all_clients',
                headers: {
                    Authorization: authHeader()
                }
            }).then(response => {
                if (response.data.msg && response.data.msg.Clients) {
                    setClients(response.data.msg.Clients);
                }
            }).catch(error => {
                console.log("Error fetching clients:", error);
            });
        };

        // Initialize form data when component mounts or user data changes
        useEffect(() => {
            if (props.data && props.data.roles) {
                // Extract role IDs from the user's current roles
                const userRoleIds = props.data.roles.map(r => r.id.toString());
                setRole(userRoleIds);
                setPermissions(
                    props.data.permissions && props.data.permissions.length > 0
                        ? props.data.permissions
                        : buildDefaultPermissionsForRoles(rolesToPermissionRoles(userRoleIds))
                );

                // Initialize commission values from existing user role data
                const initialCommissions = {};
                props.data.roles.forEach(roleData => {
                    // Check if the role has commission data (from UserRole)
                    initialCommissions[roleData.id.toString()] = roleData.commission || 0;

                    // Initialize Operador local commission if present
                    if (roleData.id === 2) {
                        setOperadorLocalCommission(roleData.local_commission || 0);
                    }
                });
                setRoleCommissions(initialCommissions);

                // Initialize client_id if user has one assigned
                if (props.data.client_id) {
                    setSelectedClientId(props.data.client_id.toString());
                }
            }
        }, [props.data]);

        const handleRoleChange = (e) => {
            const selectedRoles = [].slice.call(e.target.selectedOptions).map(item => item.value);
            setRole(selectedRoles);
            setPermissions(buildDefaultPermissionsForRoles(rolesToPermissionRoles(selectedRoles)));

            // Keep commission entries for selected roles, add default 0 for new roles
            const newRoleCommissions = {};
            selectedRoles.forEach(roleId => {
                newRoleCommissions[roleId] = roleCommissions[roleId] || 0;
            });
            setRoleCommissions(newRoleCommissions);

            // Reset Operador commission fields if Operador is deselected
            if (!selectedRoles.includes('2')) {
                setOperadorLocalCommission('');
            }

            // Reset client selection if Cliente role is deselected
            if (!selectedRoles.includes('11')) {
                setSelectedClientId('');
            }
        };

        const handleCommissionChange = (roleId, commission) => {
            setRoleCommissions(prev => ({
                ...prev,
                [roleId]: parseFloat(commission) || 0
            }));
        };

        const handlePermissionChange = (pageKey, action, checked) => {
            setPermissions(prev => prev.map(permission => {
                if (permission.page_key !== pageKey) {
                    return permission;
                }

                return {
                    ...permission,
                    [`can_${action}`]: checked
                };
            }));
        };

        const handleButtonClick = (event) => {
            // alert('Botón de Guardar presionado');
            event.preventDefault();
            const apiUrl = process.env.REACT_APP_URL;

            // Create role-commission mapping for the API
            const rolesWithCommissions = role.map(roleId => {
                const roleData = {
                    role_id: roleId,
                    commission: roleCommissions[roleId] || 0
                };

                // Add Operador-specific local commission
                if (roleId === '2') {
                    roleData.local_commission = parseFloat(operadorLocalCommission) || 0;
                }

                return roleData;
            });

            const data = {
                'id': props.data.id,  // Add user ID for update
                'first_name': event.target.firstName.value,
                'last_name': event.target.lastName.value,
                'roles': role,  // Changed from role_id to roles for multiple roles
                'role_commissions': rolesWithCommissions,
                'permissions': permissions,
                'email': event.target.email.value,
                'phone_number': event.target.phoneNumber.value,
                'location': event.target.location.value,
                'dob': event.target.dob.value,
                'salary': parseFloat(event.target.salary.value) || 0,
                'client_id': selectedClientId || null,
                'rfc': event.target.rfc.value || null,
                'num_licencia': event.target.num_licencia.value || null,
                'domicilio_fiscal_cp': event.target.domicilio_fiscal_cp.value || null
            }

            // Only include password if it's not empty
            if (event.target.password.value.trim() !== '') {
                data.password = event.target.password.value;
            }

            axios({
                method:'PUT',
                url:apiUrl+'/users/signup',
            headers: {
                Authorization: authHeader()
            },
                data: data
            }).then(response => {
                console.log(response);
                props.onHide();
            })
            .catch(error => {
                console.log(error);
                alert(error);
            });
        }
        return (
            <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Editar Usuario
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Container>
                        <Form onSubmit={handleButtonClick}>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="firstName">
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control defaultValue={props.data.first_name}/>
                                </Form.Group>
                                <Form.Group as={Col} controlId="lastName">
                                    <Form.Label>Apellido</Form.Label>
                                    <Form.Control defaultValue={props.data.last_name} />
                                </Form.Group>
                                <Form.Group as={Col} controlId="roll">
                                    <Form.Label>Rol</Form.Label>
                                    <Form.Control as="select" multiple value={role} onChange={handleRoleChange}>
                                        {/* <option value="1">Admin</option> */}
                                        <option value="2">Operador</option>
                                        <option value="3">Vendedor</option>
                                        <option value="4">Tráfico</option>
                                        <option value="5">Monitorista</option>
                                        <option value="6">Compras</option>
                                        <option value="7">Finanzas</option>
                                        <option value="8">RRHH</option>
                                        <option value="9">Facturación</option>
                                        <option value="10">Taller</option>
                                        <option value="11">Cliente</option>
                                    </Form.Control>
                                </Form.Group>
                            </Row>

                            {/* Client selection dropdown - only shown when Cliente role is selected */}
                            {isClienteRoleSelected && (
                                <Row className="mb-3">
                                    <Form.Group as={Col} controlId="clientId">
                                        <Form.Label>Asignar a Cliente *</Form.Label>
                                        <Form.Select
                                            value={selectedClientId}
                                            onChange={(e) => setSelectedClientId(e.target.value)}
                                            required={isClienteRoleSelected}
                                        >
                                            <option value="">Seleccionar cliente...</option>
                                            {clients.map(client => (
                                                <option key={client.id} value={client.id}>
                                                    {client.company_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Text className="text-muted">
                                            Este usuario solo podrá ver información de este cliente.
                                        </Form.Text>
                                    </Form.Group>
                                </Row>
                            )}


                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" defaultValue={props.data.email} />
                                </Form.Group>
                                <Form.Group as={Col} controlId="password">
                                    <Form.Label>Contraseña</Form.Label>
                                    <Form.Control placeholder="Dejar vacío para mantener actual" />
                                </Form.Group>
                                <Form.Group as={Col} controlId="phoneNumber">
                                    <Form.Label>Celular</Form.Label>
                                    <Form.Control defaultValue={props.data.phone_number} />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="location">
                                    <Form.Label>Sede</Form.Label>
                                    <Form.Select defaultValue={props.data.location || "Guadalajara, Jalisco"}>
                                        <option>Guadalajara, Jalisco</option>
                                        <option>Monterrery, Nuevo Leon</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col} controlId="dob">
                                    <Form.Label>Fecha de nacimiento</Form.Label>
                                    <Form.Control
                                        type="date"
                                        defaultValue={props.data.dob}
                                    />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <h6>SAT / Carta Porte (Operadores)</h6>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="rfc">
                                    <Form.Label>RFC</Form.Label>
                                    <Form.Control placeholder="XAXX010101000" defaultValue={props.data.rfc || ""} />
                                </Form.Group>
                                <Form.Group as={Col} controlId="num_licencia">
                                    <Form.Label>No. Licencia</Form.Label>
                                    <Form.Control placeholder="Número de licencia" defaultValue={props.data.num_licencia || ""} />
                                </Form.Group>
                                <Form.Group as={Col} controlId="domicilio_fiscal_cp">
                                    <Form.Label>C.P. Fiscal</Form.Label>
                                    <Form.Control placeholder="44100" defaultValue={props.data.domicilio_fiscal_cp || ""} />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="salary">
                                    <Form.Label>Salario Base</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        placeholder="0.00"
                                        defaultValue={props.data.salary}
                                    />
                                </Form.Group>
                            </Row>
                            {/* Commission inputs for each selected role */}
                            {role.length > 0 && (
                                <Row className="mb-3">
                                    <Col>
                                        <Form.Label><strong>Comisiones por Rol</strong></Form.Label>
                                        {role.map(roleId => (
                                            <Row key={roleId} className="mb-2">
                                                {roleId === '2' ? (
                                                    <>
                                                        <Form.Group as={Col} controlId={`commission-${roleId}`}>
                                                            <Form.Label>{roleLabels[roleId]} - Comisión Foránea (%)</Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                min="0"
                                                                max="100"
                                                                step="0.1"
                                                                placeholder="0.0%"
                                                                value={roleCommissions[roleId] || ''}
                                                                onChange={(e) => handleCommissionChange(roleId, e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="operadorLocalCommission">
                                                            <Form.Label>{roleLabels[roleId]} - Comisión Local ($)</Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                min="0"
                                                                step="0.01"
                                                                placeholder="$0.00"
                                                                value={operadorLocalCommission}
                                                                onChange={(e) => setOperadorLocalCommission(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </>
                                                ) : (
                                                    <Form.Group as={Col} controlId={`commission-${roleId}`}>
                                                        <Form.Label>{roleLabels[roleId]} - Comisión (%)</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            min="0"
                                                            max="100"
                                                            step="0.1"
                                                            placeholder="0.0%"
                                                            value={roleCommissions[roleId] || ''}
                                                            onChange={(e) => handleCommissionChange(roleId, e.target.value)}
                                                        />
                                                    </Form.Group>
                                                )}
                                            </Row>
                                        ))}
                                    </Col>
                                </Row>
                            )}
                            <Row className="mb-3">
                                <Col>
                                    <Form.Label><strong>Permisos por Página</strong></Form.Label>
                                    <div className="table-responsive">
                                        <table className="table table-sm align-middle">
                                            <thead>
                                                <tr>
                                                    <th>Página</th>
                                                    <th>Leer</th>
                                                    <th>Escribir</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {PERMISSION_PAGES.map(page => {
                                                    const permission = permissions.find(item => item.page_key === page.pageKey) || {};
                                                    return (
                                                        <tr key={page.pageKey}>
                                                            <td>
                                                                <div>{page.label}</div>
                                                                <small className="text-muted">{page.sectionTitle}</small>
                                                            </td>
                                                            {['read', 'write', 'delete'].map(action => (
                                                                <td key={action}>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        checked={Boolean(permission[`can_${action}`])}
                                                                        onChange={(e) => handlePermissionChange(page.pageKey, action, e.target.checked)}
                                                                        aria-label={`${page.label} ${action}`}
                                                                    />
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </Col>
                            </Row>
                            <Button type="submit" value="Submit">Guardar</Button>
                        </Form>
                    </Container>
                </Modal.Body>
            </Modal>
        );

}

class ModalWithGrid extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = { modalShow: false };
    }

    render() {
        let add_new_user = () => {this.props.setData(); this.setState({ modalShow: false });}
        return (
            <ButtonToolbar>
                <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => this.setState({ modalShow: true })}
                >
                    <Icon.Edit size={14} />
                </Button>
                <DefaultModal show={this.state.modalShow} onHide={add_new_user} data={this.props.user}/>
            </ButtonToolbar>
        );
    }
}

export default ModalWithGrid;
